import { render, staticRenderFns } from "./HomeDashboardPage.vue?vue&type=template&id=b8f7e12a&scoped=true"
import script from "./HomeDashboardPage.vue?vue&type=script&lang=js"
export * from "./HomeDashboardPage.vue?vue&type=script&lang=js"
import style0 from "./HomeDashboardPage.vue?vue&type=style&index=0&id=b8f7e12a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8f7e12a",
  null
  
)

export default component.exports